 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "assets/js/" + ({"v-auth-forbidden":"v-auth-forbidden","v-auth-login":"v-auth-login","v-auth-logout":"v-auth-logout","v-dashboard~v-orders-detail~v-orders-mails~v-orders-voigtdetail":"v-dashboard~v-orders-detail~v-orders-mails~v-orders-voigtdetail","v-dashboard":"v-dashboard","v-orderreturns-detail~v-orders-detail~v-users":"v-orderreturns-detail~v-orders-detail~v-users","v-orders-detail":"v-orders-detail","v-orders-mails":"v-orders-mails","v-orders-voigtdetail":"v-orders-voigtdetail","v-giftcards-add~v-giftcards-detail~v-graduatediscounts-add~v-graduatediscounts-detail~v-locations-ad~ca5aeaa9":"v-giftcards-add~v-giftcards-detail~v-graduatediscounts-add~v-graduatediscounts-detail~v-locations-ad~ca5aeaa9","v-giftcards-add":"v-giftcards-add","v-giftcards-detail":"v-giftcards-detail","v-graduatediscounts-add":"v-graduatediscounts-add","v-graduatediscounts-detail":"v-graduatediscounts-detail","v-locations-add":"v-locations-add","v-locations-addresses-detail":"v-locations-addresses-detail","v-locations-detail":"v-locations-detail","v-locations-notes":"v-locations-notes","v-locations-users":"v-locations-users","v-orderreturns-detail":"v-orderreturns-detail","v-productpopularities-detail":"v-productpopularities-detail","v-users-add":"v-users-add","v-users-addresses-add":"v-users-addresses-add","v-users-addresses-detail":"v-users-addresses-detail","v-users-detail":"v-users-detail","v-users-locations-add":"v-users-locations-add","v-users-notes":"v-users-notes","v-vouchers-add":"v-vouchers-add","v-vouchers-detail":"v-vouchers-detail","v-giftcards~v-graduatediscounts~v-locations~v-locations-addresses~v-orderreturns~v-orders~v-productp~12ef809e":"v-giftcards~v-graduatediscounts~v-locations~v-locations-addresses~v-orderreturns~v-orders~v-productp~12ef809e","v-giftcards":"v-giftcards","v-graduatediscounts":"v-graduatediscounts","v-locations":"v-locations","v-locations-addresses":"v-locations-addresses","v-orderreturns":"v-orderreturns","v-users":"v-users","v-orders":"v-orders","v-productpopularities":"v-productpopularities","v-users-addresses":"v-users-addresses","v-vouchers":"v-vouchers","v-locations-changetracking~v-orders-changetracking~v-users-changetracking":"v-locations-changetracking~v-orders-changetracking~v-users-changetracking","v-locations-changetracking":"v-locations-changetracking","v-orders-changetracking":"v-orders-changetracking","v-users-changetracking":"v-users-changetracking","v-notfound":"v-notfound","v-users-locations":"v-users-locations","v-users-logins":"v-users-logins","v-users-services":"v-users-services","v-vouchers-discounts":"v-vouchers-discounts","v-vouchers-discounts-add":"v-vouchers-discounts-add","v-vouchers-discounts-edit":"v-vouchers-discounts-edit"}[chunkId]||chunkId) + "." + {"chunk-2d0c0480":"aab21fa7","chunk-2d2102c8":"2cd97159","v-auth-forbidden":"5c7a050b","v-auth-login":"955cb009","v-auth-logout":"bf5b203a","v-dashboard~v-orders-detail~v-orders-mails~v-orders-voigtdetail":"e8a598b1","v-dashboard":"e4d407cd","v-orderreturns-detail~v-orders-detail~v-users":"cc0627df","v-orders-detail":"f4d1e219","v-orders-mails":"171e7635","v-orders-voigtdetail":"1b3d74ab","v-giftcards-add~v-giftcards-detail~v-graduatediscounts-add~v-graduatediscounts-detail~v-locations-ad~ca5aeaa9":"ae09779d","v-giftcards-add":"371f06e5","v-giftcards-detail":"e3b5ff95","v-graduatediscounts-add":"82b2bf65","v-graduatediscounts-detail":"97c712ba","v-locations-add":"18d924e9","v-locations-addresses-detail":"2e75462b","v-locations-detail":"05db7cbb","v-locations-notes":"2b2ca27e","v-locations-users":"983b6ad8","v-orderreturns-detail":"6cdac889","v-productpopularities-detail":"efe44723","v-users-add":"821933f4","v-users-addresses-add":"1222d737","v-users-addresses-detail":"f906ad90","v-users-detail":"d67ab3b2","v-users-locations-add":"8ce04a58","v-users-notes":"8990f474","v-vouchers-add":"760c777f","v-vouchers-detail":"28b6eac0","v-giftcards~v-graduatediscounts~v-locations~v-locations-addresses~v-orderreturns~v-orders~v-productp~12ef809e":"53ba0ebe","v-giftcards":"70f09737","v-graduatediscounts":"de38277d","v-locations":"d0fb9855","v-locations-addresses":"829e7630","v-orderreturns":"8f3745c9","v-users":"cb10054c","v-orders":"28a46622","v-productpopularities":"a5152951","v-users-addresses":"7833cb03","v-vouchers":"9653b405","v-locations-changetracking~v-orders-changetracking~v-users-changetracking":"7b5c596c","v-locations-changetracking":"9691044b","v-orders-changetracking":"173ce092","v-users-changetracking":"084a05da","v-notfound":"80fda5f9","v-users-locations":"e943e9ce","v-users-logins":"d66e8a57","v-users-services":"1bdc116b","v-vouchers-discounts":"a3cab5bb","v-vouchers-discounts-add":"0a0a40af","v-vouchers-discounts-edit":"0549112a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"v-dashboard~v-orders-detail~v-orders-mails~v-orders-voigtdetail":1,"v-orders-detail":1,"v-orders-mails":1,"v-orders-voigtdetail":1,"v-giftcards-add~v-giftcards-detail~v-graduatediscounts-add~v-graduatediscounts-detail~v-locations-ad~ca5aeaa9":1,"v-giftcards-add":1,"v-giftcards-detail":1,"v-graduatediscounts-add":1,"v-graduatediscounts-detail":1,"v-locations-add":1,"v-locations-addresses-detail":1,"v-locations-detail":1,"v-locations-notes":1,"v-locations-users":1,"v-orderreturns-detail":1,"v-productpopularities-detail":1,"v-users-add":1,"v-users-addresses-add":1,"v-users-addresses-detail":1,"v-users-detail":1,"v-users-locations-add":1,"v-users-notes":1,"v-vouchers-add":1,"v-vouchers-detail":1,"v-giftcards~v-graduatediscounts~v-locations~v-locations-addresses~v-orderreturns~v-orders~v-productp~12ef809e":1,"v-giftcards":1,"v-graduatediscounts":1,"v-locations":1,"v-orderreturns":1,"v-users":1,"v-orders":1,"v-productpopularities":1,"v-vouchers":1,"v-locations-changetracking~v-orders-changetracking~v-users-changetracking":1,"v-users-locations":1,"v-users-logins":1,"v-users-services":1,"v-vouchers-discounts-add":1,"v-vouchers-discounts-edit":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "assets/css/" + ({"v-auth-forbidden":"v-auth-forbidden","v-auth-login":"v-auth-login","v-auth-logout":"v-auth-logout","v-dashboard~v-orders-detail~v-orders-mails~v-orders-voigtdetail":"v-dashboard~v-orders-detail~v-orders-mails~v-orders-voigtdetail","v-dashboard":"v-dashboard","v-orderreturns-detail~v-orders-detail~v-users":"v-orderreturns-detail~v-orders-detail~v-users","v-orders-detail":"v-orders-detail","v-orders-mails":"v-orders-mails","v-orders-voigtdetail":"v-orders-voigtdetail","v-giftcards-add~v-giftcards-detail~v-graduatediscounts-add~v-graduatediscounts-detail~v-locations-ad~ca5aeaa9":"v-giftcards-add~v-giftcards-detail~v-graduatediscounts-add~v-graduatediscounts-detail~v-locations-ad~ca5aeaa9","v-giftcards-add":"v-giftcards-add","v-giftcards-detail":"v-giftcards-detail","v-graduatediscounts-add":"v-graduatediscounts-add","v-graduatediscounts-detail":"v-graduatediscounts-detail","v-locations-add":"v-locations-add","v-locations-addresses-detail":"v-locations-addresses-detail","v-locations-detail":"v-locations-detail","v-locations-notes":"v-locations-notes","v-locations-users":"v-locations-users","v-orderreturns-detail":"v-orderreturns-detail","v-productpopularities-detail":"v-productpopularities-detail","v-users-add":"v-users-add","v-users-addresses-add":"v-users-addresses-add","v-users-addresses-detail":"v-users-addresses-detail","v-users-detail":"v-users-detail","v-users-locations-add":"v-users-locations-add","v-users-notes":"v-users-notes","v-vouchers-add":"v-vouchers-add","v-vouchers-detail":"v-vouchers-detail","v-giftcards~v-graduatediscounts~v-locations~v-locations-addresses~v-orderreturns~v-orders~v-productp~12ef809e":"v-giftcards~v-graduatediscounts~v-locations~v-locations-addresses~v-orderreturns~v-orders~v-productp~12ef809e","v-giftcards":"v-giftcards","v-graduatediscounts":"v-graduatediscounts","v-locations":"v-locations","v-locations-addresses":"v-locations-addresses","v-orderreturns":"v-orderreturns","v-users":"v-users","v-orders":"v-orders","v-productpopularities":"v-productpopularities","v-users-addresses":"v-users-addresses","v-vouchers":"v-vouchers","v-locations-changetracking~v-orders-changetracking~v-users-changetracking":"v-locations-changetracking~v-orders-changetracking~v-users-changetracking","v-locations-changetracking":"v-locations-changetracking","v-orders-changetracking":"v-orders-changetracking","v-users-changetracking":"v-users-changetracking","v-notfound":"v-notfound","v-users-locations":"v-users-locations","v-users-logins":"v-users-logins","v-users-services":"v-users-services","v-vouchers-discounts":"v-vouchers-discounts","v-vouchers-discounts-add":"v-vouchers-discounts-add","v-vouchers-discounts-edit":"v-vouchers-discounts-edit"}[chunkId]||chunkId) + "." + {"chunk-2d0c0480":"31d6cfe0","chunk-2d2102c8":"31d6cfe0","v-auth-forbidden":"31d6cfe0","v-auth-login":"31d6cfe0","v-auth-logout":"31d6cfe0","v-dashboard~v-orders-detail~v-orders-mails~v-orders-voigtdetail":"2a96f4aa","v-dashboard":"31d6cfe0","v-orderreturns-detail~v-orders-detail~v-users":"31d6cfe0","v-orders-detail":"96f371af","v-orders-mails":"1905a858","v-orders-voigtdetail":"1905a858","v-giftcards-add~v-giftcards-detail~v-graduatediscounts-add~v-graduatediscounts-detail~v-locations-ad~ca5aeaa9":"640ae3a1","v-giftcards-add":"22724581","v-giftcards-detail":"4a6a0a94","v-graduatediscounts-add":"22724581","v-graduatediscounts-detail":"4a6a0a94","v-locations-add":"22724581","v-locations-addresses-detail":"4a6a0a94","v-locations-detail":"4a6a0a94","v-locations-notes":"22724581","v-locations-users":"22724581","v-orderreturns-detail":"7cab6084","v-productpopularities-detail":"4a6a0a94","v-users-add":"22724581","v-users-addresses-add":"22724581","v-users-addresses-detail":"4a6a0a94","v-users-detail":"4a6a0a94","v-users-locations-add":"22724581","v-users-notes":"22724581","v-vouchers-add":"22724581","v-vouchers-detail":"4a6a0a94","v-giftcards~v-graduatediscounts~v-locations~v-locations-addresses~v-orderreturns~v-orders~v-productp~12ef809e":"3ce68e3b","v-giftcards":"a782f96f","v-graduatediscounts":"a782f96f","v-locations":"2a53c6ed","v-locations-addresses":"31d6cfe0","v-orderreturns":"2a53c6ed","v-users":"dd0dece5","v-orders":"2a53c6ed","v-productpopularities":"2a53c6ed","v-users-addresses":"31d6cfe0","v-vouchers":"a782f96f","v-locations-changetracking~v-orders-changetracking~v-users-changetracking":"93a3ad55","v-locations-changetracking":"31d6cfe0","v-orders-changetracking":"31d6cfe0","v-users-changetracking":"31d6cfe0","v-notfound":"31d6cfe0","v-users-locations":"70a58610","v-users-logins":"947d9946","v-users-services":"2a96f4aa","v-vouchers-discounts":"31d6cfe0","v-vouchers-discounts-add":"22724581","v-vouchers-discounts-edit":"22724581"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
